export const cultures = {
    italian: "it",
    english: "en"
}
